import { Component, OnInit } from '@angular/core';
import { AlertController, MenuController, ModalController, Platform } from '@ionic/angular';
import { Plugins } from '@capacitor/core';
import { HttpClient } from '@angular/common/http';
import { VersaoService } from './shared/services/vesao.service';
import { SwUpdate } from '@angular/service-worker';
import { Router } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { MenuService, Page } from './shared/services/menu.service';
import { Observable } from 'rxjs';
import { detailExpand, rotatedState } from './shared/animations/animations';
import { NotificacaoService } from './shared/services/notificacao.service';
import { AplicativoService } from './shared/services/aplicativo.service';
import { concatMap } from 'rxjs/operators';
import { compareVersions } from '@angular/compiler-cli/src/diagnostics/typescript_version';
import { ModalStatusAppPage } from './shared/modals/modal-status-app/modal-status-app.page';
import { ModalAtualizacaoAppPage } from './shared/modals/modal-atualizacao-app/modal-atualizacao-app.page';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { UserProvider } from './providers/user.provider';

const { SplashScreen, StatusBar } = Plugins;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [ 'app.component.scss' ],
  animations: [ detailExpand, rotatedState ]
})
export class AppComponent implements OnInit {
  isDesktop: boolean;
  isTablet: boolean;
  versao = '';
  user: any;
  pages$: Observable<Page[]>;

  private plataformaUtilizada;
  private versaoIos;
  private versaoAndroid;
  private versaoPwa;

  constructor(
    private http: HttpClient,
    private menuCtrl: MenuController,
    private platform: Platform,
    private alertCtrl: AlertController,
    private authService: AuthService,
    private router: Router,
    private swUpdate: SwUpdate,
    private versaoService: VersaoService,
    private menuService: MenuService,
    private menuController: MenuController,
    private notificacaoService: NotificacaoService,
    private aplicativoService: AplicativoService,
    private modalController: ModalController,
    private appVersion: AppVersion,
    private userProvider: UserProvider
  ) {
    this.isDesktop = platform.is('desktop');
    this.isTablet = platform.is('tablet');
    this.initializeApp();
  }

  ngOnInit() {
    this.menuCtrl.enable(true);
    this.user = this.authService.getUser();
  }

  initializeApp() {
    this.carregaVersionFile();
    this.platform.ready().then(async () => {
      // this.versaoService.carregarVersao();
      // this.versaoService.versao$.subscribe((versao) => {
      //   this.versao = versao;
      // });
      if (this.platform.is('hybrid')) {
        StatusBar.setBackgroundColor({
          color: '#4C35FF'
        });
        setTimeout(() => {
          SplashScreen.hide();
        }, 2000);
      }
      this.pages$ = this.menuService.getPages();
      await this.getUser();
      await this.checkForUpdate();
      if (await this.authService.isAuthenticated()) {
        this.getNotificacaoes();
      }
    });

    this.aplicativoService.getBundle().pipe(
      concatMap((bundle) => {
        return this.aplicativoService.getByBundleId(bundle);
      })).subscribe(async (app) => {

      if (this.platform.is('ios')) {
        this.plataformaUtilizada = 'ios';
        await this.verificarAtivo(app.plataformas.situacaoIos, app.plataformas.versaoIos);
      } else if (this.platform.is('android')) {
        this.plataformaUtilizada = 'android';
        await this.verificarAtivo(app.plataformas.situacaoAndroid, app.plataformas.versaoAndroid);
      } else if (!this.platform.is('hybrid')) {
        this.plataformaUtilizada = 'pwa';
        await this.verificarAtivo(app.plataformas.situacaoPwa, app.plataformas.versaoPwa);
      }
    });
  }

  async getUser() {
    this.user = await this.authService.getUser();
    this.menuService.updatePages(this.user);
    if (this.user) {
      await this.menuController.enable(true);
    }
    this.authService.getUserAsync().subscribe((user) => {
      this.user = user;
      this.menuService.updatePages(user);
    });
  }

  async checkForUpdate() {
    // tslint:disable-next-line:no-console
    console.info('check for update sem refresh');
    this.swUpdate.available.subscribe(event => {
      this.confirmUpdateApp();
      // tslint:disable-next-line:no-console
      console.info('current version is ', event.current, ' available version is ', event.available);
    });
    this.swUpdate.activated.subscribe(event => {
      // tslint:disable-next-line:no-console
      console.info('old version was ', event.current, ' new version is ', event.previous);
    });
  }

  async confirmUpdateApp() {
    const alert = await this.alertCtrl.create({
      header: 'Atualizar aplicação',
      message: 'Existe uma nova versão disponível, deseja atualizar?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
        }, {
          text: 'Sim',
          handler: () => {
            window.location.reload();
          }
        }
      ]
    });
    await alert.present();
  }

  async sair() {
    const alert = await this.alertCtrl.create({
      header: 'Atenção',
      message: 'Deseja realmente <strong>sair</strong>?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sim',
          handler: () => {
            this.authService.clearAuthorizationToken();
            this.router.navigate([ '/login' ]).then(() => this.menuCtrl.enable(false));
          }
        }
      ]
    });
    await alert.present();
  }

  getNotificacaoes() {
    this.notificacaoService.getOne('totais').subscribe((total: any) => {
      this.menuService.setContadorPages(total.naoLido);
    });
  }

  async carregaVersionFile() {
    if (this.platform.is('hybrid')) {
      this.versao = await this.appVersion.getVersionNumber();
      await this.userProvider.setVersion(this.versao);
    } else {
      this.http.get('/assets/version.json').subscribe((res: any) => {
        this.versao = res.versao;
        this.userProvider.setVersion(this.versao);
      });
    }
  }

  async verificarAtivo(situacao, versao) {
    if (situacao === 'I') {
      const modal = await this.modalController.create({
        component: ModalStatusAppPage,
        cssClass: 'modal-status',
        backdropDismiss: false
      });
      return await modal.present();
    } else {
      await this.verificarVersao(versao);
    }
  }

  async verificarVersao(versaoEsperada) {
    const numeroVersaoAtual = this.versao.split('-')[0];
    const numeroVersaoEsperada = versaoEsperada.split('-')[0];

    console.log(`🟢 ${ this.plataformaUtilizada }
Versão Atual: ${ numeroVersaoAtual }       (${ this.versao })
Versão Esperada: ${ numeroVersaoEsperada }    (${ versaoEsperada })\n\n`);

    if (compareVersions(numeroVersaoAtual, numeroVersaoEsperada) < 0) {
      const modal = await this.modalController.create({
        component: ModalAtualizacaoAppPage,
        cssClass: 'my-custom-class',
        backdropDismiss: false
      });
      return await modal.present();
    }
  }
}
